import api from './api';
import { ItemFormData } from '../types/item';

export const itemService = {
  getItems: async (params?: { page?: number; limit?: number; search?: string }) => {
    const response = await api.get('/items', { params });
    return response.data;
  },

  createItem: async (data: ItemFormData) => {
    const response = await api.post('/items', data);
    return response.data;
  },

  updateItem: async (id: number, data: ItemFormData) => {
    const response = await api.put(`/items/${id}`, data);
    return response.data;
  },

  deleteItem: async (id: number) => {
    const response = await api.delete(`/items/${id}`);
    return response.data;
  }
};

export default itemService;